import React, {useEffect, useState} from "react";
import {IProductBase} from "../../models/Search";
import { MessageBar, MessageBarType } from "@fluentui/react";
import { useGetAllVendorSettingsQuery } from "../../store/Api";
import RichTextField from "../Common/RichTextField";

interface IBasicDetailsProps {
    product: IProductBase;
    onChange?: (product: IProductBase) => void;
    editMode?: boolean;
    id?: string;
}

const BasicDetails: React.FC<IBasicDetailsProps> = (props) => {
    const [id, setId] = useState<string | undefined>();
    const vendorSettings = useGetAllVendorSettingsQuery();

    useEffect(() => {
        if (id !== props.id) {
            setId(props.id);
        }
    }, [props.id, id]);
    
    if (props.product.descriptionSource) {
        return <>
            {props.editMode && <MessageBar messageBarType={MessageBarType.info}>
                This product description is controlled by {vendorSettings.data?.items.find(vs => vs.sourceVendor === props.product.descriptionSource)?.vendorDisplayName ?? props.product.descriptionSource}.
                To change this, navigate to the "Vendor" tab.
            </MessageBar>}
            <div dangerouslySetInnerHTML={{ __html: props.product.description || '' }} />
        </>
    }

    return(
        <RichTextField
            readOnly={!props.editMode}
            value={props.product.description}
            mode={'html'}
            onChange={(value) => {
                if (!props.onChange) return;
                props.onChange({...props.product, description: value});
            }}
        />)

};

export default BasicDetails;